import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders, uaeProjectsBaseURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { VALIDATE_LOCATION, VALIDATE_LOCATION_ERROR, VALIDATE_LOCATION_SUCCESS } from '../../actions';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

function* getValidateLocation({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/v1/validate-location`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
      },
      data: {
        ...payload?.data,
      },
    });

    if (response.status === 200) {
      yield put({
        type: VALIDATE_LOCATION_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: VALIDATE_LOCATION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: VALIDATE_LOCATION_ERROR, payload: error });
  }
}

export function* watchGetValidateLocation() {
  yield takeEvery(VALIDATE_LOCATION, getValidateLocation);
}

function* getValidateLocationSaga() {
  yield all([fork(watchGetValidateLocation)]);
}

export default getValidateLocationSaga;
